<template>
  <div :class="classNameWrapper">
    <input
      ref="input"
      type="text"
      :id="id"
      :name="name"
      :class="classNameInput"
      :placeholder="placeholder"
      v-model="user"
      autocomplete="off"
      @keyup='onKeyup($event)'
      @keyup.enter='setData()'
    />

    <div class="autocomplete-items" v-show="showList()">
      <div v-for="data in list" :key="data[item_key]">
        <div :class="[{ 'active': data.actived }]">
          <a href="javascript:void(0)" @click.prevent="setData(data)"> {{ data[item_text] }} </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { request } from '@/request'
export default {
  props: {
    id: String,
    name: String,
    placeholder: String,
    model: Object,
    urlsource: String,
    propsource: String,
    classNameWrapper: String,
    classNameInput: String,
    classNameList: {
      type: String,
      default: ''
    },
    classNameListItem: String,
    item_key: String,
    item_text: String,
    onSetData: Function
  },
  data () {
    return {
      source: [],
      list: [],
      selectedIndex: -1,
      user: ''
    }
  },
  mounted () {
    var me = this
    request
    .get(this.urlsource)
    .then(r => {
      var data = r
      if (this.propsource.length > 0) {
        data = r[this.propsource]
      }
      var s = data.map(i => {
        i.actived = i.selected = false
        return i
      })
      me.source = s
      me.list = s
    })
    .catch(e => {
      console.log(e)
    })
  },
  methods: {
    showList () {
      return this.user.length > 0 && this.list.length > 0
    },
    onKeyup (event) {
      if (event.keyCode === 38 || event.keyCode === 40) {
        this.toogleActive(event)
      } else if (this.user.length > 0) {
        this.filter()
      }
    },
    toogleActive (event) {
      var kcode = event.keyCode
      var currentIndex = this.selectedIndex

      if (kcode === 38) {
        if (this.selectedIndex === 0) {
          return
        }
        this.selectedIndex--
      }
      if (kcode === 40) {
        if (this.selectedIndex === (this.list.length - 1)) {
          return
        }
        this.selectedIndex++
      }

      if (currentIndex > -1) {
        this.list[currentIndex].actived = false
      }

      this.list[this.selectedIndex].actived = true
    },
    filter () {
      var m = this
      var value = m.user.toLowerCase()
      m.list = m.source.filter((item) => {
        return item[m.item_text].toLowerCase().indexOf(value) > -1
      })
    },
    setData (item) {
      // var u = {}
      // if (this.selectedIndex > -1) {
      //   u = this.list[this.selectedIndex]
      // } else {
      //   u = this.list[0]
      // }
      this.onSetData(item)
      item.actived = false
      // u.actived = false
      this.user = ''
      this.selectedIndex = -1
    }
  }
}
</script>

<style>
    .autocomplete-items {
    border: 1px solid #d4d4d4;
    border-bottom: none;
    border-top: none;
    z-index: 99;
    left: 0;
    right: 0;
  }
  .autocomplete-items div div {
    padding: 10px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: 1px solid #d4d4d4;
  }
  /* .autocomplete-items div:hover {
    background-color: #e9e9e9;
  } */
  .autocomplete-active {
    background-color: DodgerBlue !important;
    color: #ffffff;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/AutoComplete.vue